import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const SplitExpenseTransactionModal = ({ transaction, onClose, onSubmit }) => {
  const [splits, setSplits] = useState([{ id: 0, amount: '', description: '', category: '', purchasedFor: '', tag: '' }]);
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (transaction?.parent?.subTransactions?.length > 0) {
      setAmount(transaction.parent.amount);
      setSplits(transaction?.parent?.subTransactions.map(split => ({
        id: split.id,
        amount: split.amount,
        description: split.description,
        category: split.category,
        purchasedFor: split.purchasedFor,
        tag: split.tag,
      })));
    } else {
      setAmount(transaction.amount);
      setSplits([{ id: 0, amount: '', description: '', category: '', purchasedFor: '', tag: '' }]);
    }
  }, [transaction]);

  const addSplit = () => {
    const totalSoFar = splits.reduce((sum, s) => sum + parseFloat(s.amount || 0), 0);
    const remaining = (amount - totalSoFar).toFixed(2);
    setSplits([...splits, { amount: remaining, description: '', category: '', purchasedFor: '', tag: '' }]);
  };

  const removeSplit = (index) => {
    const updated = splits.filter((_, i) => i !== index);
    setSplits(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...splits];
    updated[index][field] = value;
    setSplits(updated);
  };

  const handleSubmit = () => {
    const total = splits.reduce((sum, s) => sum + parseFloat(s.amount || 0), 0);
    if (Math.abs(total - amount) > 0.01) {
      alert(`Total (${total.toFixed(2)}) does not match original amount (${amount.toFixed(2)})`);
      return;
    }
    onSubmit(transaction.parent ? transaction.parent.id : transaction.id, splits);
    onClose();
  };

  /* fullscreen="md-down"*/

  return (
    <Modal show onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Split Transaction - {transaction.merchant} (${(amount).toFixed(2)})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2 fw-bold text-muted">
          <Col xs={6} md={3}>Amount</Col>
          <Col xs={12} md={2}>Description</Col>
          <Col xs={12} md={2}>Category</Col>
          <Col xs={6} md={2}>Purchased For</Col>
          <Col xs={12} md={2}>Tag</Col>
          <Col xs={6} md={1}></Col>
        </Row>
        {splits.map((split, index) => (
          <Row key={index} style={{ whiteSpace: 'nowrap' }} className="mb-3 align-items-end border-bottom pb-2">
            <Col xs={6} md={3}>
              <div className="d-flex align-items-center gap-1">
                <Form.Control
                  type="number"
                  step="0.01"
                  value={split.amount}
                  onChange={(e) => handleChange(index, 'amount', e.target.value)}
                  className="flex-grow-1 me-1"
                />
                <Button
                  variant="outline-secondary"
                  style={{ fontSize: '0.75rem', padding: '0.4rem'}}
                  onClick={() => {
                    const newAmount = (parseFloat(split.amount || 0) * 1.1).toFixed(2);
                    handleChange(index, 'amount', newAmount);
                  }}
                  >+10%</Button>
              </div>
            </Col>
            <Col xs={12} md={2}>
              <Form.Control
                value={split.description}
                onChange={(e) => handleChange(index, 'description', e.target.value)}
              />
            </Col>
            <Col xs={12} md={2}>
              <Form.Control
                value={split.category}
                onChange={(e) => handleChange(index, 'category', e.target.value)}
              />
            </Col>
            <Col xs={6} md={2}>
              <Form.Control
                value={split.purchasedFor}
                onChange={(e) => handleChange(index, 'purchasedFor', e.target.value)}
              />
            </Col>
            <Col xs={12} md={2}>
              <Form.Control
                value={split.tag}
                onChange={(e) => handleChange(index, 'tag', e.target.value)}
              />
            </Col>
            <Col xs={6} md={1} className="text-end">
              <Button variant="danger" size="sm" onClick={() => removeSplit(index)}>✕</Button>
            </Col>
          </Row>
        ))}
        <Button variant="outline-primary" onClick={addSplit}>Add Split</Button>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="success" onClick={handleSubmit}>Save Split</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SplitExpenseTransactionModal;